import React, { useContext, useState, useEffect } from "react";
import { StoreContext } from "../../context/StoreContext.jsx";
import { useNavigate } from "react-router-dom";
import { FaSpinner, FaTrash, FaMobileAlt } from "react-icons/fa";
import Modal from "react-modal";
// --- MODIFICATION START ---
import { calculateCartTotals, verifyGuestFirebase } from '../../api/apiService';
import { formatPrice } from '../../utils/formatPrice';
// +++ IMPORT FIREBASE +++
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../utils/firebase";
// --- MODIFICATION END ---
import "./Cart.css";

Modal.setAppElement('#root');

function Cart() {
    const {
        cart,
        clearUserCart,
        currency,
        loading,
        token,
        user,
        updateItemQuantity,
        guestVerified,
        setGuestVerified,
        // guestEmail, // No longer needed here
        // setGuestEmail, // No longer needed here
        setGuestPhone, // +++ GET GUEST PHONE SETTER +++
        vendor_names,
        authLoading
    } = useContext(StoreContext);

    const navigate = useNavigate();
    const [isUpdating, setIsUpdating] = useState(false);
    const [billDetails, setBillDetails] = useState({
        subtotal: 0,
        taxAmount: 0,
        taxes:0,
        platformFee: 0,
        deliveryCharge: 0,
        netAmount: 0
    });
    const [isCalculating, setIsCalculating] = useState(false);
    const [showGuestModal, setShowGuestModal] = useState(false);

    // --- MODIFICATION: Change from Email to Phone ---
    const [localGuestPhone, setLocalGuestPhone] = useState("");
const [countryCode, setCountryCode] = useState("+91");
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [verifying, setVerifying] = useState(false);
    const [otpError, setOtpError] = useState("");
    const [firebaseConfirmation, setFirebaseConfirmation] = useState(null);
    const [isRecaptchaReady, setIsRecaptchaReady] = useState(false); // +++ ADD THIS LINE +++
    // --- END MODIFICATION ---

    const isLoggedIn = !!user && !!token;

    const formatCurrency = (amount) =>
        typeof amount === "number" ? amount.toFixed(2) : "0.00";

    useEffect(() => {
        const fetchTotals = async () => {
            if (cart?._id && cart.items.length > 0) {
                setIsCalculating(true);
                try {
                    const payload = { cart_id: cart._id };
                    const response = await calculateCartTotals(payload);
                    if (response.success) {
                        setBillDetails({
                            subtotal: response.totals.subtotal,
                            taxAmount: response.totals.taxAmount,
                            platformFee: response.totals.platformFee,
                            deliveryCharge: response.totals.deliveryCharge,
                            netAmount: response.totals.netAmount,
                            taxes: response.totals.taxes,
                            isFirstOrder: response.totals.isFirstOrder // ✅ Capture the flag
                        });
                    }
                } catch (error) {
                    console.error("Failed to calculate cart totals:", error);
                    setBillDetails({ subtotal: 0, taxAmount: 0, platformFee: 0, deliveryCharge: 0, netAmount: 0 });
                } finally {
                    setIsCalculating(false);
                }
            } else {
                setBillDetails({ subtotal: 0, taxAmount: 0, platformFee: 0, deliveryCharge: 0, netAmount: 0 });
            }
        };

        fetchTotals();
    }, [cart]);

    // NOTE: removed previous useEffect that initialized RecaptchaVerifier here
    // Initialization will be done AFTER the modal is rendered via onAfterOpen

    const handleUpdateQuantity = async (cartItemId, newQuantity) => {
        setIsUpdating(true);
        await updateItemQuantity(cartItemId, newQuantity);
        setIsUpdating(false);
    };

    const handleClearCart = async () => {
        if (window.confirm("Are you sure you want to clear your entire cart?")) {
            setIsUpdating(true);
            await clearUserCart();
            if (!isLoggedIn) {
                setGuestVerified(false);
                setGuestPhone("");
            }
            setIsUpdating(false);
        }
    };

    const handleProceedToCheckout = () => {
        if (isLoggedIn || guestVerified) {
            navigate('/order');
        } else {
            setShowGuestModal(true);
        }
    };

    // --- RE-WRITE Guest OTP modal logic for FIREBASE PHONE ---
    const handleSendOtp = async () => {
        setOtpError("");
        const phoneLengthMap = {
  "+91": 10,
//   "+1": 10,
};

if (!localGuestPhone || localGuestPhone.length !== phoneLengthMap[countryCode]) {
            setOtpError("Please enter a valid 10-digit phone number.");
            return;
        }
        if (!isRecaptchaReady) {
            setOtpError("Verification is not ready yet, please wait a moment.");
            return;
        }
        setVerifying(true);
        try {
            const appVerifier = window.recaptchaVerifierGuest;
            if (!appVerifier) {
                throw new Error("reCAPTCHA not ready. Please try again.");
            }
            
            const phoneNumber = `${countryCode}${localGuestPhone}`;
            const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
            
            setFirebaseConfirmation(confirmation);
            setOtpSent(true);
        } catch (err) {
            console.error("Firebase OTP Send Error:", err);
            setOtpError(err?.message || "Failed to send OTP. Please try again.");
            if (window.recaptchaVerifierGuest) {
                try {
                   window.recaptchaVerifierGuest.render().then(widgetId => {
                       if(window.grecaptcha) window.grecaptcha.reset(widgetId);
                   });
                } catch(e) { /* ignore */ }
            }
        } finally {
            setVerifying(false);
        }
    };

    const handleVerifyOtp = async () => {
        setOtpError("");
        if (!otp || otp.length !== 6) {
            setOtpError("Please enter the 6-digit OTP.");
            return;
        }
        if (!firebaseConfirmation) {
            setOtpError("Verification session expired. Please resend OTP.");
            return;
        }
        setVerifying(true);
        try {
            const result = await firebaseConfirmation.confirm(otp);
            const firebaseToken = await result.user.getIdToken();
            const guest_id = localStorage.getItem("guest_id");

            // Call backend endpoint
            await verifyGuestFirebase({ firebaseToken, guest_id });

            // Success: update context and proceed
            // cleanup recaptcha + modal state before navigating
            cleanupRecaptchaOnModalClose();
            setGuestPhone(`${countryCode}${localGuestPhone}`);
            setGuestVerified(true);
            setOtpError("");
            navigate("/order");
        } catch (err) {
            console.error("Guest OTP Verify Error:", err);
            setOtpError(err?.response?.data?.message || err?.message || "OTP verification failed.");
        } finally {
            setVerifying(false);
        }
    };

    // +++ ADD THIS FUNCTION +++
    // This runs AFTER the modal is open, guaranteeing the div exists
    const initializeRecaptchaOnModalOpen = async () => {
        setIsRecaptchaReady(false); // Reset readiness
        setOtpError("");
        
        const container = document.getElementById('recaptcha-container-guest');
        if (container) container.innerHTML = ''; // Clear old instance

        try {
            const verifier = new RecaptchaVerifier(
                auth,
                'recaptcha-container-guest',
                {
                    'size': 'invisible',
                    'callback': () => console.log("Guest reCAPTCHA verified")
                }
            );
            await verifier.render(); // Wait for it to render
            window.recaptchaVerifierGuest = verifier;
            setIsRecaptchaReady(true); // Now it's ready!
        } catch (error) {
            console.error("Failed to init reCAPTCHA:", error);
            setOtpError("Failed to initialize verification. Please refresh.");
            setIsRecaptchaReady(false);
        }
    };

    // +++ ADD THIS FUNCTION +++
    // This cleans up when the modal closes
    const cleanupRecaptchaOnModalClose = () => {
        if (window.recaptchaVerifierGuest) {
            try {
                window.recaptchaVerifierGuest.clear();
                window.recaptchaVerifierGuest = null;
            } catch (e) { /* ignore */ }
        }
        setIsRecaptchaReady(false);
        setOtpSent(false); // Reset OTP state
        setOtp("");
        setLocalGuestPhone("");
        setShowGuestModal(false);
    };

    if (loading) {
        return (
            <div className="orders-loading-viewport">
                <div className="loading-state">
                    <div className="loading-content">
                        <div className="loading-icon">🛍️</div>
                        <div className="loading-shimmer"></div>
                        <div style={{ marginTop: 18, fontWeight: 600, color: "#27ae60" }}>Loading your cart...</div>
                    </div>
                </div>
            </div>
        );
    }

    const itemsInCart = cart?.items || [];

    return (
        <div className="cart-page-wrapper">
            {isUpdating && (
                <div className="cart-update-overlay">
                    <FaSpinner className="animate-spin" size={32} />
                </div>
            )}
            <h1 className="cart-page-heading">Your Cart</h1>
            <div className="cart-layout">
                <div className="cart-items-section">
                    {itemsInCart.length === 0 ? (
                        <div className="empty-cart-state">
                            <h3 className="empty-cart-message">Your cart is currently empty!</h3>
                            <button className="browse-button" onClick={() => navigate('/')}>Start Shopping</button>
                        </div>
                    ) : (
                        <>
                            {cart?.vendor_id && vendor_names?.[cart?.vendor_id] && (
                                <p className="cart-vendor-info">Order from: <span>{vendor_names[cart.vendor_id]}</span></p>
                            )}
                            <div className="cart-items-table-header">
                                <span className="header-item">Item</span>
                                <span className="header-name">Name</span>
                                <span className="header-price">Price</span>
                                <span className="header-qty">Quantity</span>
                                <span className="header-total">Total</span>
                                <span className="header-remove"></span>
                            </div>
                            <hr className="table-header-divider" />
                            <div className="cart-items-list">
                                {itemsInCart.map((item) => (
                                    <div className="cart-item-card" key={item._id}>
                                        <img src={item.image || "https://via.placeholder.com/100"} alt={item.name} className="item-image" />
                                        <span className="item-name">{item.name}</span>
                                        <span className="item-price">{formatPrice(item.price_per_unit, cart.currency, currency)}</span>
                                        <div className="item-quantity-controls">
                                            <button className="quantity-button decrease" onClick={() => handleUpdateQuantity(item._id, item.quantity - 1)} disabled={isUpdating}>−</button>
                                            <span className="quantity-value">{item.quantity}</span>
                                            <button className="quantity-button increase" onClick={() => handleUpdateQuantity(item._id, item.quantity + 1)} disabled={isUpdating}>+</button>
                                        </div>
                                        <span className="item-total">{formatPrice(item.price_per_unit * item.quantity, cart.currency, currency)}</span>
                                        <button className="remove-item-button" onClick={() => handleUpdateQuantity(item._id, 0)} disabled={isUpdating}><FaTrash /></button>
                                    </div>
                                ))}
                            </div>
                            <button className="clear-cart-button" onClick={handleClearCart} disabled={isUpdating || itemsInCart.length === 0}>Clear All Items</button>
                        </>
                    )}
                </div>
                <div className="cart-summary-section">
                    <div className="cart-summary-card">
                        <h2>Order Summary</h2>
                        <div className="summary-row">
                            <span>Item Total</span>
                            <span className="amount">{formatPrice(billDetails.subtotal, cart.currency, currency)}</span>
                        </div>
                        <div className="summary-row">
                            <span>Discount</span>
                            <span className="amount">- {formatPrice(0, cart.currency, currency)}</span>
                        </div>
                        {(cart?.currency === 'USD' || cart?.currency === 'CAD') && (
                            <div className="summary-row">
                                <span>Estimated Tax</span>
                                <span className="amount">{formatPrice(0, cart.currency, currency)}</span>
                            </div>
                        )}
                       <div className="summary-row">
    <span>Platform Fee + GST</span>
    <span className="amount">
        {billDetails.isFirstOrder ? (
            <>
                <span
                    style={{
                        textDecoration: 'line-through',
                        color: '#999',
                        marginRight: '8px',
                        fontSize: '0.9em'
                    }}
                >
                    {formatPrice(
                        15 + billDetails.taxAmount,
                        cart.currency,
                        currency
                    )}
                </span>

                <span style={{ color: '#2ecc71', fontWeight: 'bold' }}>
                    {formatPrice(
                        0,
                        cart.currency,
                        currency
                    )}
                </span>
            </>
        ) : (
            itemsInCart.length > 0
                ? formatPrice(
                    billDetails.platformFee + billDetails.taxAmount,
                    cart.currency,
                    currency
                )
                : formatPrice(0, cart.currency, currency)
        )}
    </span>
</div>
                        <div className="summary-row">
                            <span>Delivery Fee</span>
                            <span className="amount">{itemsInCart.length > 0 ? formatPrice(billDetails.deliveryCharge, cart.currency, currency) : formatPrice(0, cart.currency, currency)}</span>
                        </div>
                        <div className="summary-row">
                            <span>Delivery Tip</span>
                            <span className="amount">{formatPrice(0, cart.currency, currency)}</span>
                        </div>
                        {billDetails.taxes > 0 && (
    <div className="summary-row">
        <span>Taxes</span>
        <span className="amount">
            {formatPrice(billDetails.taxes, cart.currency, currency)}
        </span>
    </div>
)}
                        <div className="summary-row final-total-row">
                            <h3>Grand Total</h3>
                            <span className="amount">{isCalculating ? <FaSpinner className="animate-spin" /> : formatPrice(billDetails.netAmount, cart.currency, currency)}</span>
                        </div>
                        {isLoggedIn ? (
                            <button className="proceed-button" onClick={handleProceedToCheckout} disabled={isUpdating || itemsInCart.length === 0 || authLoading || isCalculating}>Proceed to Checkout</button>
                        ) : (
                            itemsInCart.length > 0 && (
                                <div className="guest-checkout-options">
                                    <button className="proceed-button" onClick={() => navigate("/login")}>Sign in to Checkout</button>
                                    
                                    {/* TEMPORARILY DISABLED GUEST CHECKOUT FOR LIVE TESTING */}
                                    <div className="or-divider"><span>or</span></div>
                                    <button className="proceed-button guest" type="button" onClick={() => setShowGuestModal(true)}>Continue as Guest</button> 
                                   

                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
            {/* Modal for guest OTP verification - UI UPDATED FOR PHONE */}
            
            {true && (
            <Modal
                isOpen={showGuestModal}
                onAfterOpen={initializeRecaptchaOnModalOpen}
                onRequestClose={cleanupRecaptchaOnModalClose}
                ariaHideApp={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                    content: {
                        position: 'static',
                        maxWidth: 400,
                        margin: 'auto',
                        borderRadius: 18,
                        padding: '2.5rem 2rem 2rem 2rem',
                        background: '#fff',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                        border: 'none',
                        minHeight: 320,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        animation: 'modalFadeIn 0.3s',
                    }
                }}
            >
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <div style={{ marginBottom: 18 }}>
                        <FaMobileAlt size={50} color="#007bff" style={{ marginBottom: 12 }} />
                        <h2 style={{ fontWeight: 700, fontSize: 24, margin: 0, color: '#222' }}>Guest Verification</h2>
                        <p style={{ color: '#666', fontSize: 15, margin: '8px 0 0 0' }}>Secure your order with a quick phone verification!</p>
                    </div>
                    {!otpSent ? (
                        <>
                            <label htmlFor="guest-phone" style={{ fontWeight: 500, fontSize: 15, color: '#333', display: 'block', marginBottom: 6 }}>Enter your phone number to continue</label>
                            <div style={{ display: 'flex', gap: '10px' }}>
  <select
    value={countryCode}
    onChange={(e) => setCountryCode(e.target.value)}
    disabled={verifying}
    style={{
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #ccc'
    }}
  >
    <option value="+91">IN +91</option>
    {/* <option value="+1">🇺🇸 +1</option>
    <option value="+1">🇨🇦 +1</option> */}
  </select>

  <input
    id="guest-phone"
    type="tel"
    value={localGuestPhone}
    onChange={e => setLocalGuestPhone(e.target.value.replace(/[^\d]/g, ""))}
    placeholder="Phone Number"
    disabled={verifying}
    style={{
      flex: 1,
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #ccc'
    }}
  />
</div>
                                
                            <button
                                className="proceed-button"
                                style={{ width: '100%', padding: '12px', fontSize: 16, borderRadius: 8, background: '#ff6f00', color: '#fff', fontWeight: 600, border: 'none', marginBottom: 8, cursor: verifying || !isRecaptchaReady ? 'not-allowed' : 'pointer', boxShadow: '0 2px 8px rgba(255,111,0,0.08)' }}
                                onClick={handleSendOtp}
                                disabled={verifying || !isRecaptchaReady} // disabled until reCAPTCHA ready
                            >
                                {verifying ? "Sending OTP..." : (!isRecaptchaReady ? "Initializing..." : "Send OTP")}
                            </button>
                        </>
                    ) : (
                        <>
                            <label htmlFor="guest-otp" style={{ fontWeight: 500, fontSize: 15, color: '#333', display: 'block', marginBottom: 6 }}>Enter OTP sent to {countryCode}{localGuestPhone}</label>
                            <input
                                id="guest-otp"
                                type="text"
                                value={otp}
                                onChange={e => setOtp(e.target.value.replace(/[^\d]/g, ""))}
                                maxLength={6}
                                placeholder="OTP"
                                disabled={verifying}
                                style={{
                                    width: '100%',
                                    padding: '12px 14px',
                                    fontSize: 16,
                                    borderRadius: 8,
                                    border: '1px solid #ccc',
                                    marginBottom: 12,
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    background: verifying ? '#f5f5f5' : '#fff',
                                    letterSpacing: 4,
                                    textAlign: 'center',
                                    transition: 'border 0.2s',
                                }}
                            />
                            <button
                                className="proceed-button"
                                style={{ width: '100%', padding: '12px', fontSize: 16, borderRadius: 8, background: '#43a047', color: '#fff', fontWeight: 600, border: 'none', marginBottom: 8, cursor: verifying ? 'not-allowed' : 'pointer', boxShadow: '0 2px 8px rgba(67,160,71,0.08)' }}
                                onClick={handleVerifyOtp}
                                disabled={verifying}
                            >
                                {verifying ? "Verifying..." : "Verify & Continue"}
                            </button>
                        </>
                    )}
                    {otpError && <div style={{ color: '#d32f2f', fontWeight: 500, marginTop: 4, marginBottom: 8, fontSize: 14 }}>{otpError}</div>}
                    
                    <div id="recaptcha-container-guest" style={{ marginTop: '10px', transform: 'scale(0.8)', transformOrigin: 'center' }}></div>
                 
                    <button onClick={cleanupRecaptchaOnModalClose} disabled={verifying} style={{ position: 'absolute', top: 18, right: 22, background: 'none', border: 'none', fontSize: 28, color: '#888', cursor: 'pointer', lineHeight: 1 }} aria-label="Close">×</button>
                </div>
            </Modal>
            )}
        </div>
    );
}

export default Cart;